import React from "react";
import { createPortal } from "react-dom";

// Portaled to <body> so animated/transformed ancestors can't change what "fixed" is relative to.
export const WhatsAppButton = ({ style }) =>
  createPortal(
    <a
      href="https://wa.me/message/BN2R4ZFIMY4JM1"
      className="whatsapp_float"
      style={style}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <i className="fa fa-whatsapp whatsapp-icon"></i>
    </a>,
    document.body
  );

export default WhatsAppButton;
